import React from 'react';
import { get } from 'lodash';

export function ErrorMessage({ formik, field }) {
  return get(formik, `touched.${field}`, false) &&
    get(formik, `errors.${field}`, false) ? (
    <div className="d-flex">
      <div className="fv-plugins-message-container">
        <div className="fv-help-block">
          {get(formik, `errors.${field}`, '')}
        </div>
      </div>
    </div>
  ) : null;
}
